import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "../index.scss";
import {
  LEFT,
  TRANSLATION_KEY_PREVIOUS,
  TRANSLATION_KEY_NEXT,
} from "../constants";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";

export const CarouselButton = ({
  direction,
  scroll,
  hasOverflow,
  isAtScrollBoundary,
}) => {
  const { getTranslation } = useRuntimeConstants();

  const disabled = !hasOverflow || isAtScrollBoundary;
  const baseClassName =
    direction === LEFT ? styles.backChevron : styles.forwardChevron;

  const translationKey =
    direction === LEFT ? TRANSLATION_KEY_PREVIOUS : TRANSLATION_KEY_NEXT;

  return (
    <button
      onClick={() => scroll(direction)}
      className={classnames(baseClassName, {
        [styles.disabled]: disabled,
      })}
      aria-label={getTranslation(translationKey)}
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    />
  );
};

CarouselButton.propTypes = {
  direction: PropTypes.string.isRequired,
  scroll: PropTypes.func.isRequired,
  hasOverflow: PropTypes.bool,
  isAtScrollBoundary: PropTypes.bool,
};
